import Postgres from "../../../../contents/docs/cdp/sources/_snippets/source-postgres.mdx";
import * as React from 'react';
export default {
  Postgres,
  React
};